<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.officeMonthlyReportList.push"
    :query-list="queryList"
    :is-show-month-range-picker="true"
    :picker-options="pickerOptions"
    :show-summary="true"
  >
    <el-table-column width="70px" label="ID" prop="id"/>

    <v-column-time field="report_date" time-format="timeToYm" value="日期"/>
    <v-column-time sortable=""/>
    <v-column-admin/>
    <el-table-column label="收入（元）" prop="all_income" type="money">
      <template v-slot="{ row }">
        <span>{{ row.all_income | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="支出（元）" prop="expenditure" type="money">
      <template v-slot="{ row }">
        <span>{{ row.expenditure | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="利润（元）" prop="profit" type="money">
      <template v-slot="{ row }">
        <span>{{ row.profit | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="提成（元）" prop="store_income" type="money">
      <template v-slot="{row}">
        <span>{{ row.store_income | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="发布状态" width="150" align="center" prop="updateState">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_draft" type="info">草稿</el-tag>
        <el-tag v-else type="success">已发布</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="310">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="browse"
          :to="RouteConfig.officeMonthlyReportDetail.to(row.id)"
        />

        <v-list-button :to="RouteConfig.officeMonthlyReportEdit.to(row.id)"/>

        <v-popover>
          <v-popover-item
            icon="bin"
            name="删除总结"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="确认要删除该月总结吗？"
          />
        </v-popover>
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`office-monthly-report-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>日期</span>
              <span>{{ v.report_date | timeToYm }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>操作员</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>收入（元）</span>
              <span>{{ v.all_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>支出（元）</span>
              <span>{{ v.expenditure | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>利润（元）</span>
              <span>{{ v.profit | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>提成（元）</span>
              <span>{{ v.store_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>发布状态</span>
              <el-tag v-if="v.is_draft" type="info">草稿</el-tag>
              <el-tag v-else type="success">已发布</el-tag>
            </div>
            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="browse"
                :to="RouteConfig.officeMonthlyReportDetail.to(v.id)"
              />
              <v-list-button :to="RouteConfig.officeMonthlyReportEdit.to(v.id)"/>
              <v-popover>
                <v-popover-item
                  icon="bin"
                  name="删除总结"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="确认要删除该月总结吗？"
                />
              </v-popover>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>收入</span>
              <span class="income-count">{{ allIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>支出</span>
              <span class="pay-count">{{ expenditure | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>利润</span>
              <span :class="profit >= 0 ? 'income-count' : 'pay-count'">{{ profit | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>提成</span>
              <span class="income-count">{{ storeIncome | toYuan }} 元</span>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, destroy } from '@/api/office-monthly-report';
import { getLegalQueryList } from "@/utils/formats";
import { plus } from '@/filters';
import { checkYmdIsBetweenSetUpAndToday } from "@/utils/validate";

export default {
  name: RouteConfig.officeMonthlyReportList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: false,
    queryList: {
      store_id: '',
      start_date: '',
      end_date: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    pickerOptions: {
      disabledDate: time => time.getTime() >= Date.now(),
      shortcuts: [
        {
          text: '上月',
          onClick(picker) {
            let currentDate = new Date();
            let lastMonth = currentDate.getMonth() - 1;
            let currentYear = currentDate.getFullYear();
            let startDate = new Date(currentYear, lastMonth,1);
            let endDate = new Date(currentYear, lastMonth, 31);
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: '去年',
          onClick(picker) {
            let currentDate = new Date();
            let currentYear = currentDate.getFullYear() - 1;
            let startDate = new Date(currentYear, 0,1);
            let endDate = new Date(currentYear, 11,31);
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: '今年',
          onClick(picker) {
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth();
            let currentYear = currentDate.getFullYear();
            let startDate = new Date(currentYear, 0,1);
            let endDate = new Date(currentYear, currentMonth,1);
            picker.$emit('pick', [startDate, endDate]);
          },
        },
      ],
    },
    count: 0,
    list: [],
    allIncome: 0,
    expenditure: 0,
    profit: 0,
    storeIncome: 0,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        queryList.start_date = '';
        queryList.end_date = '';
      }

      this.isLoading = true;
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      this.count = data.count;
      this.list = data.list;

      const list = data.list;
      const length = list.length;

      let allIncome = 0;
      let expenditure = 0;
      let profit = 0;
      let storeIncome = 0;

      for (let i = 0; i < length; i++) {
        allIncome = plus(allIncome, list[i].all_income);
        expenditure = plus(expenditure, list[i].expenditure);
        profit = plus(profit, list[i].profit);
        storeIncome = plus(storeIncome, list[i].store_income);
      }

      Object.assign(this, {
        allIncome,
        expenditure,
        profit,
        storeIncome,
      });
    },
    async handleDelete(id) {
      if (this.isDeleting) return;

      this.isDeleting = true;
      const { isError } = await destroy(id);
      this.isDeleting = false;
      if (isError) return;

      this.load();
    },
  },
};
</script>
